var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkBox_head " }, [
    _c("div", { staticClass: "search" }, [
      _c("span", { staticClass: "current_tit" }, [_vm._v("当前区域：")]),
      _c("div", { staticClass: "margin-right_20" }, [
        _c("span", [_vm._v(_vm._s(_vm.location.site))]),
        _vm.location.site
          ? _c("span", [_vm._v("附近" + _vm._s(_vm.toThousands) + "以内园区")])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }